"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpsellMixin = void 0;
var _drywall = require("drywall");
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _CloseButton = require("../../components/CloseButton/CloseButton.styles");
var _Heading = require("../../components/Heading/Heading.styles");
var _Icon = require("../../components/Icon/Icon.styles");
var _Image = require("../../components/Image/Image.styles");
var _TextButton = require("../../components/TextButton/TextButton.styles");
var _spaceMixin = require("../spaceMixin");
var _statusDialogMixin = require("../statusDialogMixin");
var _typographyMixin = require("../typographyMixin");
var columnCSS = (0, _styledToken.default)('Upsell.columnMediaSize', function (maxHeight) {
  return (0, _styledComponents.css)(["", "{", ",", "{max-width:100%;max-height:", "px;}}"], _drywall.MediaObject.Media, _Image.StyledImage, _Icon.StyledIcon, maxHeight);
});
var rowCSS = (0, _styledToken.default)('Upsell.rowMediaSize', function (size) {
  return (0, _styledComponents.css)(["", "{height:", "px;width:", "px;flex-shrink:0;", ",", "{height:100%;width:100%;}}"], _drywall.MediaObject.Media, size, size, _Image.StyledImage, _Icon.StyledIcon);
});
var textButtonCSS = function textButtonCSS(props) {
  return (0, _styledComponents.css)(["", "{margin:", " 0 0;padding:0;display:flex;}"], _TextButton.StyledTextButton, (0, _spaceMixin.spaceMixin)('xs')(props));
};
var directionCSS = function directionCSS(props) {
  var direction = props.direction;
  var styles = [];
  if (direction === 'column') {
    styles.push(columnCSS(props));
  } else {
    styles.push(rowCSS(props));
  }
  return styles;
};
var colorCSS = function colorCSS(props) {
  var background = props.background;
  return (0, _styledToken.default)({
    backgroundColor: "colors." + background,
    borderColor: "colors." + background
  }, {
    defaultValue: ''
  }, function (tokens) {
    var styles = ["background-color: " + tokens.backgroundColor + "};"];
    if (background === 'backgroundDarkBlue') {
      styles.push((0, _statusDialogMixin.statusDialogMixin)(Object.assign({
        inverse: true
      }, props)));
    }
    if (background !== 'backgroundWhite') {
      styles.push("border-color: " + tokens.borderColor + "};");
    }
    return styles;
  })(props);
};

/** @class UpsellMixin */
/** @method */
var UpsellMixin = function UpsellMixin(props) {
  return (0, _styledToken.default)('Upsell.headingFontType', function (fontType) {
    return (0, _styledComponents.css)(["", "{", " ", "}position:relative;", "{position:absolute;top:", ";right:", ";}", "{display:flex;flex-direction:column;align-items:start;}", " ", " ", ""], _Heading.StyledHeading, (0, _typographyMixin.typographyMixin)(Object.assign({
      fontType: fontType
    }, props)), props.closeable && props.direction === 'row' ? (0, _styledComponents.css)(["padding-right:", ";"], (0, _spaceMixin.spaceMixin)('lg')(props)) : '', _CloseButton.StyledCloseButton, (0, _spaceMixin.spaceMixin)('sm')(props), (0, _spaceMixin.spaceMixin)('sm')(props), _drywall.MediaObject.Body, colorCSS(props), directionCSS(props), textButtonCSS(props));
  })(props);
};
exports.UpsellMixin = UpsellMixin;